import React from 'react';
import NavLink from 'ui-components/NavLink';

const ThanksLink = () => (
	<NavLink title="special thanks" to="/gallery/ty" id="thanks-link">
	    <div className="hoveroff"></div>
	    <div className="hoveron"></div>
	</NavLink>
);
export default ThanksLink;